<template>
  <nav class="navbar">
    <!-- LOGO -->
    <router-link to="/" class="logo" v-if="!isMobile">
      <img src="/logo.png" alt="LOGO" class="logo-image" />
    </router-link>

    <div class="mobile-header" v-if="isMobile">
      <i class="fas fa-search search-icon" @click="toggleSearch"></i>
      <router-link to="/" class="mobile-logo">
        <img src="/logo.png" alt="LOGO" />
      </router-link>
      <div class="hamburger" @click="toggleMenu">
        <i :class="isMenuOpen ? 'fas fa-times close-icon' : 'fas fa-bars'"></i>
      </div>
    </div>

    <!-- 手機版選單 -->
    <!-- 手機版選單 -->
<div v-if="isMenuOpen" class="mobile-menu-overlay">
  <!-- 背景遮罩 -->
  <div class="menu-backdrop" @click="closeMenu"></div>
  <!-- 選單內容 -->
  <ul class="mobile-menu">
    <li class="menu-item" @click="navigateTo('/applications')">應用工具</li>
    <li class="menu-item" @click="navigateTo('/framework')">開發工具</li>
    <li class="menu-item" @click="navigateTo('/models')">語言模型</li>
    <li
      v-for="page in pages"
      :key="page.name"
      class="menu-item"
      @click="navigateTo(page.link)"
    >
      {{ page.name }}
    </li>
  </ul>
</div>



    <!-- 電腦版選單 -->
    <ul class="desktop-menu" v-if="!isMobile">
      <li class="search-container">
        <i class="fas fa-search search-icon" @click="toggleSearch"></i>
      </li>
      <li class="menu-item" @click="navigateTo('/applications')">應用工具</li>
      <li class="menu-item" @click="navigateTo('/framework')">開發工具</li>
      <li class="menu-item" @click="navigateTo('/models')">語言模型</li>
      <li
        v-for="page in pages"
        :key="page.name"
        class="menu-item"
        @click="navigateTo(page.link)"
      >
        {{ page.name }}
      </li>
    </ul>

    <!-- 搜尋框 -->
    <div v-if="showSearch" class="search-overlay" @click.self="closeSearch">
      <div class="search-popup">
        <input
          type="text"
          placeholder="搜尋..."
          class="search-input"
          v-model="searchQuery"
          @keyup.enter="handleSearch"
          ref="searchInput"
        />
        <button class="submit-btn" @click="handleSearch">送出</button>
      </div>
    </div>
  </nav>
</template>



<script>
export default {
  name: "Navbar",
  data() {
    return {
      isMenuOpen: false,
      showSearch: false,
      searchQuery: "",
      isMobile: window.innerWidth <= 768,
      pages: [
        { name: "關於我們", link: "/about-us" },
        { name: "網站導覽", link: "/WebsiteGuide" },
      ],
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (this.isMenuOpen) this.showSearch = false;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    toggleSearch() {
      this.showSearch = true;
      this.isMenuOpen = false;
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      });
    },
    closeSearch() {
      this.showSearch = false;
    },
    handleSearch() {
      if (this.searchQuery.trim()) {
        this.$router.push({
          name: "SearchAll",
          params: { keyword: this.searchQuery.trim() },
        });
      }
      this.closeSearch();
    },
    navigateTo(link) {
      this.$router.push(link).then(() => {
        this.isMenuOpen = false;
      });
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
/* LOGO 樣式 */
.logo-image {
  width: 150px;
  height: auto;
  object-fit: contain;
}

/* Navbar 樣式 */
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: #e8e8e8;
  border-bottom: 1px solid #e0e0e0;
  position: relative; /* 讓子元素可以定位 */
  z-index: 10;
}

/* 搜尋圖標 */
.search-icon {
  font-size: 20px;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 電腦版選單 */
.desktop-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 10px;
}

.desktop-menu .menu-item {
  padding: 10px 20px;
  cursor: pointer;
  background-color: #f0f0f0;
  border-radius: 2px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.desktop-menu .menu-item:hover {
  background-color: #333;
  color: white;
  font-weight: bolder;
}

/* 手機版圖標 */
.mobile-icons {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.hamburger {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 25px;
  height: 18px;
  cursor: pointer;
}



.hamburger .line {
  width: 100%;
  height: 3px;
  background-color: #333;
}

/* 手機版選單 */
.mobile-menu-overlay {
  position: absolute;
  top: 100%; /* navbar 下方 */
  left: 0;
  width: 100%;
  height: 100%;
  background-color:  rgba(0, 0, 0, 0.5); /* 半透明背景 */
  z-index: 9999; /* 確保在 navbar 下層但高於其他內容 */
  border-top: 1px solid #ddd;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  flex-direction: column; /* 垂直排列 */
  align-items: flex-start;
  display: flex;
  justify-content: flex-start;
}

.mobile-menu {
  width: 100%; /* 占滿寬度 */
  background-color: #fff; /* 選單本身的背景色 */
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid #ddd;
}

.menu-item {
  padding: 15px 20px;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

.mobile-header,
.mobile-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%; /* 填滿頁面寬度 */
  padding: 10px 20px; /* 保持內邊距一致 */
  background-color: #e8e8e8; /* 相同背景色 */
  border-bottom: 1px solid #ddd; /* 添加下邊框 */
}

.mobile-logo img {
  height: 30px;
  object-fit: contain;
}

.close-icon {

  font-size: 20px;
  cursor: pointer;
}

.mobile-menu .menu-item {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
}

.mobile-menu .menu-item:hover {
  background-color: #f5f5f5;
}

/* 搜尋框 */
.search-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 9999999;
}

.search-popup {
  position: absolute;
  top: 70px;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.search-input {
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 80%;
  margin-bottom: 10px;
}

.submit-btn {
  background-color: #333;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.submit-btn:hover {
  background-color: #555;
}

/* 搜尋圖標 */
.search-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%; /* 保持與其他選單項目相同的高度 */
  padding: 10px; /* 添加內間距確保外觀一致 */
}

.search-icon {
  font-size: 20px;
  color: #333;
  cursor: pointer;
}

/* RWD */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .mobile-icons {
    display: flex;
  }

  .menu-item {
    margin: 0;
  }
}
</style>
